import NextLink from "next/link";
import { PropertyDataV2 } from "commonModule/services/common";
import LazyLoadedImage from "components/slider/LazyLoadedImage";
import { FALLBACK_LOGO_IMAGE } from "constant";
import { getPropertyTypeDesc } from "utils/property-utils";
import { customSlugify } from "utils/url";
const TravelAgentPropertyCard = ({
  property,
  isLazy = true
}: {
  property: PropertyDataV2;
  isLazy?: boolean;
}) => {
  const coverImage = property.images?.[0];
  const imageUrl = coverImage?.image_full_url ?? FALLBACK_LOGO_IMAGE;
  const propertyTypeLabel = getPropertyTypeDesc(property?.propertyTypeDesc || "", property?.city || "", property?.state || "", property?.country || "");
  const query = new URLSearchParams();
  if (property.checkInDate && property.checkOutDate) {
    query.set("check_in", property.checkInDate);
    query.set("check_out", property.checkOutDate);
  }
  query.set("adultsCount", "2");
  query.set("childrenCount", "0");
  query.set("allInPriceToggle", "true");
  const propertyUrl = `/detail/${customSlugify(property.propertyName) || "Whimstay"}/${property.oldPropertyId}?${query.toString()}`;
  return <NextLink href={propertyUrl} target='_blank' className='block w-[234px] flex-shrink-0 overflow-hidden rounded-2xl bg-white md:w-[400px]' data-sentry-element="NextLink" data-sentry-component="TravelAgentPropertyCard" data-sentry-source-file="TravelAgentPropertyCard.tsx">
      <div className='aspect-[400/365] w-full overflow-hidden'>
        <LazyLoadedImage src={imageUrl} alt={property.propertyName} className='h-full w-full object-cover' isLazy={isLazy} readyToLoad readyToLoadHighRes={false} data-sentry-element="LazyLoadedImage" data-sentry-source-file="TravelAgentPropertyCard.tsx" />
      </div>

      <div className='px-3 py-2 text-center md:px-5 md:py-3'>
        <h3 className='truncate text-xs font-semibold leading-[0.96em] text-secondary-500 md:text-xl md:leading-[0.96em]'>
          {propertyTypeLabel}
        </h3>
        <p className='mt-1 text-[9px] leading-[1.28em] text-Gray-700 md:mt-2 md:text-[15px]'>
          {property.noOfGuest} guests &middot; {property.noOfBedroom} bedrooms
          &middot; {property.noOfBathroom} bathrooms
        </p>
      </div>
    </NextLink>;
};
export default TravelAgentPropertyCard;